import React from 'react';
import { Section, YouAreHereDot } from './Section';
export function BigIdea() {
  return <Section tone="graphite" labelledBy="big-idea-title" data-id="element-21" data-mp="2p9f2iuuc228a">
      <div className="mx-auto max-w-4xl" data-id="element-22" data-mp="2pc19as9egdpg">
        <h2 id="big-idea-title" className="font-serif text-3xl font-semibold leading-[1.15] text-creme md:text-[2.75rem]" data-id="element-23" data-mp="2u8jcvoszu607">
          Ce qui sépare un parcours interrompu à la quatrième séance d’un
          parcours mené jusqu’à la dixième, ce n’est pas le talent du coach.
        </h2>

        <p className="mt-10 flex items-center gap-4 font-serif text-3xl italic text-creme md:text-4xl" data-id="element-24" data-mp="26ki88qyxr9q2">
          <YouAreHereDot data-id="element-25" data-mp="2bhibku4ehydh" />
          C’est le cadre.
        </p>

        <p className="mt-10 max-w-prose text-base leading-relaxed text-creme/70 md:text-lg" data-id="element-26" data-mp="2g9054x43gwof">
          Le talent fait de bonnes séances. Le cadre fait un parcours. Un client
          qui ne voit pas son progrès finit par conclure qu’il n’y en a pas — et
          ce qui reste invisible finit par sembler facultatif. La formation vous
          a donné la posture. Elle parle peu de la quatrième séance, un mardi
          soir.
        </p>
      </div>
    </Section>;
}